import SkillsInterests from './skillsInterests'
export default SkillsInterests
